import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Toast, Modal } from 'antd-mobile'
import commonAction from '../../actions/common'
import {
  getAssignPageList,
  deleteAssign,
  changeAssignStatus,
} from '../../api/TaskAssigned'
import ScrollBox from '../../components/ScrollBox'
import NoData from '../../components/NoData'
import Lodding from '../../components/Lodding'
import Drawer from '../../components/Drawer'
import AddAssign from './components/AddAssign'
import './index.scss'

const TASK_TYPE_MAP = { 1: '维保', 2: '维修' }
const STATUS_MAP = { 1: '启用', 2: '禁用' }
const EXECUTE_STATUS_MAP = { 0: '待执行', 1: '已执行' }

class TaskAssigned extends Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      isCanLoading: true,
      scrollHight: 0,
      animating: false,
      // 搜索抽屉
      searchOpen: false,
      searchNickname: '',
      searchPhone: '',
      searchStatus: '',
      // 新增/编辑弹窗
      addVisible: false,
      editData: null,
    }
    this.pageIndex = 1
    this.pageSize = 20
    this.totalPage = 0
  }

  componentDidMount() {
    const pathname = this.props.path
    this.props.dispatch({ type: commonAction.setPathname, pathname })
    this.props.onRef(this)
    this.handleRefresh()
  }

  // Header 右侧按钮触发
  submit = () => {
    this.setState({ searchOpen: true })
    return ''
  }

  // 列表请求
  fetchList = async () => {
    this.setState({ animating: true })
    const { searchNickname, searchPhone, searchStatus } = this.state
    const params = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
    }
    if (searchNickname) params.nickname = searchNickname
    if (searchPhone) params.phone = searchPhone
    if (searchStatus !== '') params.status = searchStatus

    try {
      const res = await getAssignPageList(params)
      if (res.code === 200 && res.data) {
        this.totalPage = Math.ceil(res.data.total / this.pageSize) || 0
        this.setState(prev => ({
          list: this.pageIndex === 1 ? (res.data.list || []) : prev.list.concat(res.data.list || []),
          isCanLoading: true,
          animating: false,
        }))
      } else {
        this.setState({ animating: false })
      }
    } catch (e) {
      this.setState({ animating: false })
      Toast.fail('请求失败', 1)
    }
  }

  // 下拉刷新
  handleRefresh = () => {
    this.pageIndex = 1
    this.totalPage = 0
    this.setState({ list: [] }, () => {
      this.fetchList()
    })
  }

  // 上拉加载
  handleScroll = () => {
    this.setState({ isCanLoading: false })
    if (this.pageIndex < this.totalPage) {
      this.pageIndex += 1
      this.fetchList()
    }
  }

  setScrollHight = (val) => {
    this.setState({ scrollHight: val })
  }

  // 搜索相关
  handleSearchClose = () => {
    this.setState({ searchOpen: false })
  }

  handleSearch = () => {
    this.setState({ searchOpen: false, list: [] })
    this.pageIndex = 1
    this.fetchList()
  }

  handleSearchReset = () => {
    this.setState({
      searchNickname: '',
      searchPhone: '',
      searchStatus: '',
    })
  }

  // 新增
  handleAdd = () => {
    this.setState({ addVisible: true, editData: null })
  }

  // 编辑
  handleEdit = (item) => {
    this.setState({ addVisible: true, editData: item })
  }

  // 新增/编辑弹窗关闭
  handleAddClose = () => {
    this.setState({ addVisible: false, editData: null })
  }

  // 新增/编辑成功回调
  handleAddSuccess = () => {
    this.setState({ addVisible: false, editData: null })
    this.handleRefresh()
  }

  // 删除
  handleDelete = (item) => {
    Modal.alert('提示', '确定要删除该任务指派吗？', [
      { text: '取消' },
      {
        text: '确定',
        onPress: async () => {
          try {
            const res = await deleteAssign({ idList: [item.id] })
            if (res.code === 200) {
              Toast.success('删除成功', 1)
              this.handleRefresh()
            } else {
              Toast.fail(res.message || '删除失败', 1)
            }
          } catch (e) {
            Toast.fail('删除失败', 1)
          }
        }
      }
    ])
  }

  // 切换状态
  handleChangeStatus = (item) => {
    const targetStatus = item.status === 1 ? 2 : 1
    const label = targetStatus === 1 ? '启用' : '禁用'
    Modal.alert('提示', `确定要${label}该任务指派吗？`, [
      { text: '取消' },
      {
        text: '确定',
        onPress: async () => {
          try {
            const res = await changeAssignStatus({
              idList: [item.id],
              status: targetStatus,
            })
            if (res.code === 200) {
              Toast.success(`${label}成功`, 1)
              this.handleRefresh()
            } else {
              Toast.fail(res.message || '操作失败', 1)
            }
          } catch (e) {
            Toast.fail('操作失败', 1)
          }
        }
      }
    ])
  }

  render() {
    const {
      list, isCanLoading, scrollHight, animating,
      searchOpen, searchNickname, searchPhone,
      searchStatus, addVisible, editData
    } = this.state

    return (
      <div className="task-assigned-page commonBodyBox">
        <div className="task-assigned-scroll">
          {list && list.length > 0 ? (
            <ScrollBox
              setScrollHight={this.setScrollHight}
              handleRefresh={this.handleRefresh}
              handleScroll={this.handleScroll}
              isCanLoading={isCanLoading}
              scrollHight={scrollHight}
            >
              <ul className="task-assigned-list">
                {list.map((item, index) => (
                  <li className="task-card" key={item.id || index}>
                    <div className="task-card-header">
                      <div className="task-card-title">
                        <span className="task-name">{item.taskName}</span>
                        <span className={`task-type type-${item.taskType}`}>
                          {TASK_TYPE_MAP[item.taskType]}
                        </span>
                      </div>
                      <span className={`task-status status-${item.status}`}>
                        {STATUS_MAP[item.status]}
                      </span>
                    </div>

                    <div className="task-card-body">
                      <div className="task-info-row">
                        <span className="label">姓名</span>
                        <span className="value">{item.nickname}</span>
                      </div>
                      <div className="task-info-row">
                        <span className="label">手机号</span>
                        <span className="value">{item.phone}</span>
                      </div>
                      <div className="task-info-row">
                        <span className="label">所属部门</span>
                        <span className="value">{item.departmentName}</span>
                      </div>
                      <div className="task-info-row">
                        <span className="label">项目</span>
                        <span className="value">{item.projectName}</span>
                      </div>
                      <div className="task-info-row">
                        <span className="label">电梯位置</span>
                        <span className="value">{item.liftLocation}</span>
                      </div>
                      <div className="task-info-row">
                        <span className="label">时间</span>
                        <span className="value">{item.startTime} ~ {item.endTime}</span>
                      </div>
                      <div className="task-info-row">
                        <span className="label">执行状态</span>
                        <span className={`value exec-status exec-${item.executeStatus}`}>
                          {EXECUTE_STATUS_MAP[item.executeStatus]}
                        </span>
                      </div>
                      {item.executeTime && (
                        <div className="task-info-row">
                          <span className="label">完成时间</span>
                          <span className="value">{item.executeTime}</span>
                        </div>
                      )}
                      <div className="task-info-row">
                        <span className="label">负责人支付金额</span>
                        <span className="value amount">{item.ownerPayAmount != null ? `¥${item.ownerPayAmount}` : '-'}</span>
                      </div>
                      <div className="task-info-row">
                        <span className="label">公司支付金额</span>
                        <span className="value amount">{item.companyPayAmount != null ? `¥${item.companyPayAmount}` : '-'}</span>
                      </div>
                    </div>

                    <div className="task-card-footer">
                      <div className="task-actions">
                        <span className="action-btn edit" onClick={(e) => { e.stopPropagation(); this.handleEdit(item) }}>编辑</span>
                        <span className="action-btn status" onClick={(e) => { e.stopPropagation(); this.handleChangeStatus(item) }}>
                          {item.status === 1 ? '禁用' : '启用'}
                        </span>
                        <span className="action-btn delete" onClick={(e) => { e.stopPropagation(); this.handleDelete(item) }}>删除</span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </ScrollBox>
          ) : (
            <NoData />
          )}
        </div>

        {/* 悬浮新增按钮 */}
        <div className="task-fab" onClick={this.handleAdd}>
          <span className="fab-icon">+</span>
        </div>

        {/* 搜索抽屉 */}
        <Drawer direction="bottom" handleClose={this.handleSearchClose} open={searchOpen}>
          <div className="search-drawer">
            <div className="search-field">
              <label>姓名</label>
              <input
                type="text"
                placeholder="请输入姓名"
                value={searchNickname}
                onChange={e => this.setState({ searchNickname: e.target.value })}
              />
            </div>
            <div className="search-field">
              <label>手机号</label>
              <input
                type="text"
                placeholder="请输入手机号"
                value={searchPhone}
                onChange={e => this.setState({ searchPhone: e.target.value })}
              />
            </div>
            <div className="search-field">
              <label>状态</label>
              <select
                value={searchStatus}
                onChange={e => this.setState({ searchStatus: e.target.value })}
              >
                <option value="">全部</option>
                <option value="1">启用</option>
                <option value="2">禁用</option>
              </select>
            </div>
            <div className="search-btns">
              <button className="btn-reset" onClick={this.handleSearchReset}>重置</button>
              <button className="btn-search" onClick={this.handleSearch}>搜索</button>
            </div>
          </div>
        </Drawer>

        {/* 新增/编辑弹窗 */}
        {addVisible && (
          <AddAssign
            visible={addVisible}
            editData={editData}
            onClose={this.handleAddClose}
            onSuccess={this.handleAddSuccess}
          />
        )}

        <Lodding animating={animating} />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

export default connect(mapStateToProps)(TaskAssigned)
